import React from "react";
import ServicePage from "@/components/ServicePage";
import { pressoterapiaData } from "@/data/services";

export default function Pressoterapia() {
    return <ServicePage data={pressoterapiaData} />;
}
